var _effectorFileName = "/builds/gmini/front-common/src/auth/ForbiddenPage.tsx";
import { memo } from 'react';
import { styled, Button } from '@mui/material';
import lock from "./lock.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ForbiddenPage = /*#__PURE__*/memo(function (_ref) {
  var onReload = _ref.onReload,
      onMainPage = _ref.onMainPage,
      onLogout = _ref.onLogout;
  return /*#__PURE__*/_jsx(Main, {
    children: /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(Image, {
          src: lock
        })
      }), /*#__PURE__*/_jsx("h3", {
        children: "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u0430\u0448\u0438\u0432\u0430\u0435\u043C\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0437\u0430\u043A\u0440\u044B\u0442"
      }), /*#__PURE__*/_jsxs(ButtonsWrapper, {
        children: [/*#__PURE__*/_jsx(ActionButton, {
          onClick: onReload,
          children: "\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
        }), /*#__PURE__*/_jsx(ActionButton, {
          onClick: onMainPage,
          children: "\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E"
        }), /*#__PURE__*/_jsx(ActionButton, {
          onClick: onLogout,
          children: "\u0412\u044B\u0439\u0442\u0438"
        })]
      })]
    })
  });
});
ForbiddenPage.displayName = 'ForbiddenPage';
var Main = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
var Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});
var ButtonsWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between'
});
var ImageWrapper = styled('div')({
  marginBottom: '10px'
});
var Image = styled('img')({
  width: '150px'
});
var ActionButton = styled(Button)({
  textTransform: 'none'
});